import React from 'react';
import { styled } from 'styled-components';
import loader from '../assets/images/loader.svg';
const Loading = (props) => {
    return (React.createElement(Loader, { alt: "", src: loader, style: {
            width: props.width ? props.width : '150px',
            ...props.style,
        }, className: "spinner" }));
};
export default Loading;
const Loader = styled.img `
  animation: 1.8s spinner ease infinite;

  @keyframes spinner {
    0% {
      transform: rotate(0) scale(1);
    }
    50% {
      transform: rotate(360deg) scale(0.9);
    }
    100% {
      transform: rotate(720deg) scale(1);
    }
  }
`;
//# sourceMappingURL=Loading.js.map